import { render, staticRenderFns } from "./ConvoStatementEdit.vue?vue&type=template&id=010426a9&"
import script from "./ConvoStatementEdit.vue?vue&type=script&lang=js&"
export * from "./ConvoStatementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports